var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-checkbox u-margin-top-24"},_vm._l((_vm.categories),function(item,idx){return _c('category-settings',{key:idx,attrs:{"category":item},on:{"click":_vm.onCategoryClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }